export const apiUrl = process.env.REACT_APP_API_URL
// export const apiUrl = "http://localhost:3003/api"
// export const apiUrl = "http://192.168.1.200:3000/api"
